<template>
  <div class="container">
    <el-tabs v-model="activeTab" type="card" closable @edit="dataTabsEdit">
      <el-tab-pane label="通用工具" name="toolsList">
        <el-row :gutter="12">
          <el-col :span="4" v-for="(item, index) in toolsList" :key="index">
            <el-card shadow="hover" style="height: 100%;">
              <div class="card-content">
                <span class="text-base">{{ item.data }}</span>
                <i class="el-icon-s-promotion blue" @click="dataEdit(item.targetName)"></i>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="化工网衍生物" name="chinachemnet" v-if="tabVisible.chinachemnet">
        <el-row>
          <el-input v-model="chinachemnetKeywords" placeholder="" clearable style="width: 300px; margin-right: 10px;"
            @clear="queryChinachemnetList()"></el-input>
          <el-button @click="chinachemnetCurrentPage = 1; queryChinachemnetList()" icon="el-icon-search" circle
            title="搜索"></el-button>
          <el-button @click="addChinachemnetTask()" icon="el-icon-plus" circle title="新建"></el-button>
        </el-row>
        <el-table :data="chinachemnetTaskList" stripe v-loading="chinachemnetTaskLoading" height="650">
          <el-table-column prop="task_name" label="任务名称">
          </el-table-column>
          <el-table-column prop="" label="原始文件">
            <template v-slot="scope">
              <el-link type="primary" @click="fileDownload(scope.row.file_path, scope.row.file_name)">{{
                scope.row.file_name }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="ignored_str" label="忽略词">
            <template v-slot="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.ignored_str" placement="top"
                v-if="scope.row.ignored_str != null && scope.row.ignored_str.length >= 18">
                <span>
                  {{ scope.row.ignored_str.substring(0, 18) + '...' }}
                </span>
              </el-tooltip>
              <span v-else>{{ scope.row.ignored_str }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="percentage" label="任务进度" sortable width="170"
            :sort-method="(a, b) => { return a.percentage - b.percentage }">
            <template v-slot="scope">
              <em v-if="scope.row.paused === true">已暂停</em>
              <em v-else>
                <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.percentage"
                  :text-color="scope.row.percentage < 50 ? '#000' : '#FFF'" :color="colors"></el-progress>
              </em>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template v-slot="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#dedede"
                @change="chinachemnetTaskToggleStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="creator" label="创建人">
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" sortable width="170">
          </el-table-column>
          <el-table-column prop="" label="文件下载">
            <template v-slot="scope">
              <em v-if="!scope.row.download_file_name && scope.row.percentage < 100">-</em>
              <em v-if="!scope.row.download_file_name && scope.row.percentage == 100">正在生成文件, 请稍候</em>
              <el-link type="primary" v-if="scope.row.download_file_name"
                @click="fileDownload(scope.row.download_file_path, scope.row.download_file_name)">
                {{ scope.row.download_file_name }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="chinachemnetTaskTotal"
            @size-change="changeChinachemnetTaskSize" @current-change="currentChinachemnetTaskChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="chinachemnetTaskSize">
          </el-pagination>
        </div>
        <el-dialog title="创建任务" :visible.sync="createChinachemnetTaskVisable">
          <el-form :model="createChinachemnetTaskForm" label-width="120px" :rules="createChinachemnetTaskRules"
            ref="createChinachemnetTaskForm">
            <el-form-item label="任务名称" prop="task_name">
              <el-col :span="17">
                <el-input placeholder="请输入内容" v-model="createChinachemnetTaskForm.task_name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="忽略词" prop="ignored">
              <el-col :span="17">
                <el-input placeholder="BP,BP98,BP93,USP,CP,IP,JP"
                  v-model="createChinachemnetTaskForm.ignored"></el-input>
                <i class="el-icon-question"><i>多个请以英文逗号隔开, 不区分大小写</i></i>
              </el-col>
            </el-form-item>
            <el-form-item label="选择文件">
              <el-col>
                <el-upload class="upload-demo" drag :action="uploadApi" :file-list="createChinachemnetTaskFileList"
                  accept=".xls,.xlsx" :limit="1" :headers="headersObj"
                  :on-success="createChinachemnetTaskUploadSuccess">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
                </el-upload>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelCreateChinachemnetTask">取 消</el-button>
            <el-button type="primary" @click="saveChinachemnetTask" v-loading="createChinachemnetTaskLoading">保
              存</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="谷歌关键字规划" name="googleAdKeywords" v-if="tabVisible.googleAdKeywords">
        即将开放
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Nav from '../Global/Nav.vue'

export default {
  name: 'Tools',
  components: {
    Nav
  },
  data() {
    return {
      activeTab: 'toolsList',
      uploadApi: this.$axios.defaults.baseURL + 'excel/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      colors: [
        { color: '#1989fa', percentage: 10 },
        { color: '#19bafa', percentage: 20 },
        { color: '#19eefa', percentage: 30 },
        { color: '#19fabe', percentage: 40 },
        { color: '#19fa7f', percentage: 50 },
        { color: '#25fa19', percentage: 60 },
        { color: '#97fa19', percentage: 70 },
        { color: '#8619fa', percentage: 80 },
        { color: '#fa7819', percentage: 90 },
        { color: '#fa1919', percentage: 100 }
      ],
      tabVisible: {
        chinachemnet: false,
        semrush: false
      },
      toolsList: [
        {
          data: '化工网衍生物',
          targetName: 'chinachemnet'
        },
        {
          data: '谷歌关键字规划',
          targetName: 'googleAdKeywords'
        }
      ],
      chinachemnetKeywords: '',
      chinachemnetTaskLoading: false,
      chinachemnetTaskList: [],
      chinachemnetTaskTotal: 0,
      chinachemnetTaskSize: 10,
      chinachemnetTaskCurrentPage: 1,
      createChinachemnetTaskVisable: false,
      createChinachemnetTaskForm: {
        task_name: '',
        ignored: ""
      },
      createChinachemnetTaskRules: {},
      createChinachemnetTaskFileList: [],
      createChinachemnetTaskLoading: false
    }
  },
  mounted() {
    this.intervals = setInterval(() => {
      if (this.activeName === 'chinachemnet') {
        this.queryChinachemnetList(false, true);
      } else if (this.activeName === 'googleAdKeywords') {
        this.queryGoogleAdKeywordsTaskList(false, true);
      }
    }, 10000);
  },
  methods: {
    dataTabsEdit(targetName, action) {
      if (action === 'remove') {
        if (targetName === 'toolsList') {
          this.$message.error('第一个标签不允许关闭');
          return false;
        }
        this.tabVisible[targetName] = false;
        this.activeTab = 'toolsList'
      }
    },
    dataEdit(targetName) {
      this.tabVisible[targetName] = true;
      this.activeTab = targetName;
      switch (targetName) {
        case 'chinachemnet':
          this.queryChinachemnetList();
          break;
      }
    },
    fileDownload(url, savename) {
      window.location.href = this.$axios.defaults.baseURL + 'files/download?url=' + url + '&savename=' + savename;
    },
    addChinachemnetTask() {
      this.createChinachemnetTaskVisable = true;
    },
    cancelCreateChinachemnetTask() {
      this.createChinachemnetTaskVisable = false;
      this.createChinachemnetTaskForm = {
        task_name: '',
        ignored: ""
      }
    },
    createChinachemnetTaskUploadSuccess(response) {
      this.createChinachemnetTaskFileList = [];
      if (response.code === 200) {
        this.createChinachemnetTaskFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    saveChinachemnetTask() {
      if (this.createChinachemnetTaskFileList.length < 1) {
        this.$notify({
          title: 'failed',
          message: '请选择文件',
          type: 'warning'
        })
        return false;
      }
      this.$refs.createChinachemnetTaskForm.validate(valid => {
        if (valid) {
          this.$notify({
            'title': '提示',
            'message': '正在创建任务, 请稍候',
            'type': 'info'
          })
          this.$axios.post('center/tools/chinachemnet/create', {
            task_name: this.createChinachemnetTaskForm.task_name,
            file_name: this.createChinachemnetTaskFileList[0].name,
            file_path: this.createChinachemnetTaskFileList[0].url,
            ignored: this.createChinachemnetTaskForm.ignored
          }).then((response) => {
            if (response.data.code === 200) {
              this.$notify({
                'title': 'success',
                'message': '创建成功',
                'type': 'success'
              })
              this.createChinachemnetTaskVisable = false;
              this.createChinachemnetTaskForm = {
                task_name: '',
                ignored: ""
              }
              this.createChinachemnetTaskFileList = [];
              this.queryChinachemnetList();
            }
          })
        }
      })
    },
    queryChinachemnetList(search = false, iv = false) {
      if (iv === false) {
        this.chinachemnetTaskLoading = true;
      }
      let current_page = search === true ? 1 : this.chinachemnetTaskCurrentPage;
      this.$axios.get(`center/tools/chinachemnet/list`, {
        params: {
          keywords: this.chinachemnetKeywords,
          size: this.chinachemnetTaskSize,
          page: current_page
        }
      }).then((response) => {
        this.chinachemnetTaskLoading = false;
        if (response.data.code === 200) {
          this.chinachemnetTaskList = response.data.data.data
          this.chinachemnetTaskTotal = response.data.data.total
        }
      });
    },
    changeChinachemnetTaskSize(val) {
      this.chinachemnetTaskSize = val;
      this.queryChinachemnetList();
    },
    currentChinachemnetTaskChange(val) {
      this.chinachemnetCurrentPage = val;
      this.queryChinachemnetList();
    },
    chinachemnetTaskToggleStatus(row) {
      this.$axios.post('center/tools/chinachemnet/toggle_status', {
        id: row.id,
        status: row.status
      }).then((response) => { })
    }
  }
}
</script>

<style scoped>
.card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-content i:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Modules/Tools.vue